<template>
  <div class="h-full flex flex-col lg:flex-row gap-3 lg:gap-4 animate-pulse">
    <!-- Desktop Layout -->
    <div class="hidden lg:flex h-full gap-4 flex-1">
      <!-- Left Panel - Contact List Skeleton -->
      <div class="w-80 flex-shrink-0 bg-white rounded-2xl shadow-xl border border-gray-200 flex flex-col">
        <!-- Search Bar Skeleton -->
        <div class="p-4 border-b border-gray-200">
          <div class="h-10 bg-gray-200 rounded-full"></div>
        </div>
        
        <!-- Contacts Skeleton -->
        <div class="flex-1 overflow-hidden">
          <ContactListSkeleton :count="8" />
        </div>
      </div>

      <!-- Right Panel - Chat Window Skeleton -->
      <div class="flex-1 bg-white rounded-2xl shadow-xl border border-gray-200">
        <ChatWindowSkeleton />
      </div>
    </div>

    <!-- Mobile Layout -->
    <div class="lg:hidden h-full">
      <!-- Contact List View -->
      <div v-if="!showChat" class="h-full bg-white rounded-2xl shadow-xl border border-gray-200 flex flex-col">
        <!-- Search Bar Skeleton -->
        <div class="p-3 border-b border-gray-200">
          <div class="h-10 bg-gray-200 rounded-full"></div>
        </div>
        
        <!-- Contacts Skeleton -->
        <div class="flex-1 overflow-hidden">
          <ContactListSkeleton :count="6" />
        </div>
      </div>

      <!-- Chat View -->
      <div v-else class="h-full bg-white rounded-2xl shadow-xl border border-gray-200">
        <ChatWindowSkeleton />
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
import ContactListSkeleton from './ContactListSkeleton.vue'
import ChatWindowSkeleton from './ChatWindowSkeleton.vue'

defineProps<{
  showChat?: boolean
}>()
</script>
